import Box from "@mui/material/Box";
import "./index.scss";

const DeleteConfirm = ({ data, deleteDraft, cancel }) => {
    return (
        <Box className="delete-layer-wrapper">
            <Box className="top-box">
                Delete " {data?.name ? data.name : 'نامشخص'}"?
            </Box>
            <Box className="actions">
                <button className="cancel" onClick={cancel}>Cancel</button>
                <button className="delete" onClick={deleteDraft}>Delete</button>
            </Box>
            
        </Box>
    )
}

export default DeleteConfirm;